module.exports = __webpack_public_path__ + "workspace/static/img/echeck.033cd4e.png";